import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingStockCountCreateView from 'src/sections/packaging-stock-count/view/packaging-stock-count-create-view';

export default function PackagingStockCountCreatePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Create a new packaging stock count</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingStockCountCreateView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
